'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _forgotPasswordModal = require('./forgot-password-modal');

var _forgotPasswordModal2 = _interopRequireDefault(_forgotPasswordModal);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _googleLoginOrSignup = require('./google-login-or-signup');

var _googleLoginOrSignup2 = _interopRequireDefault(_googleLoginOrSignup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _loginCaptcha = require('./login-captcha');

var _loginCaptcha2 = _interopRequireDefault(_loginCaptcha);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

var _baseForm = require('common/components/base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * NOTE: This form does not follow the proper way to use
 * React and Symfony Forms, a better example can be found
 * by looking at ForgotPasswordForm
 */
var LogInForm = _baseForm2['default'].createFormClass({

    displayName: 'LogInForm',

    propTypes: {
        'header': _react2['default'].PropTypes.string,
        'buttonText': _react2['default'].PropTypes.string,
        'googleOpenIdUrl': _react2['default'].PropTypes.string,
        'redirectUrl': _react2['default'].PropTypes.string,
        'onErrorRedirectUrl': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'closeAfterLogin': _react2['default'].PropTypes.bool,
        'emailAddress': _react2['default'].PropTypes.string, // FIXME: Should be refactored to come from loginForm.values (same with errors instead of parsing if from the URL)
        'recaptchaPublicKey': _react2['default'].PropTypes.string,
        'displayCaptcha': _react2['default'].PropTypes.bool,
        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'async': _react2['default'].PropTypes.bool,
        'hideRememberMe': _react2['default'].PropTypes.bool,
        'hideGoogleOpenId': _react2['default'].PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'async': true,
            'displayCaptcha': false,
            'action': '/account/logIn'
        };
    },
    getInitialState: function getInitialState() {
        var emailAddress = this.props.emailAddress;
        var href = decodeURIComponent(location.href);

        var matches = href.match(/email\=([^&]+)/i);
        if (matches && matches.length > 1) {
            emailAddress = matches[1];
        }

        if (!emailAddress) {
            matches = href.match(/login_default_email\=([^&]+)/i);
            if (matches && matches.length > 1) {
                emailAddress = matches[1];
            }
        }

        var redirectUrl = this.props.redirectUrl;
        if (!redirectUrl) {
            matches = href.match(/on_login_redirect_url\=([^&]+)/i);
            if (matches && matches.length > 1) {
                redirectUrl = matches[1];
            }
        }

        return {
            'password': '',
            'emailAddress': emailAddress,
            'isProcessing': false,
            'redirectUrl': redirectUrl,
            'closeAfterLogin': /\?close_after_login\=1|&close_after_login\=1/i.test(href),
            'isCaptchaDisplayed': this.props.displayCaptcha
        };
    },
    componentDidMount: function componentDidMount() {
        var root = $(_reactDom2['default'].findDOMNode(this));
        var emailInput = root.find('input[name=\'login[email_address]\']');
        var pwdInput = root.find('input[name=\'login[password]\']');
        if (emailInput.length === 1 && !this.state.emailAddress) {
            (0, _setTimeout2['default'])(function () {
                emailInput.focus();
            }, 500);
        } else if (this.state.emailAddress && pwdInput.length === 1) {
            (0, _setTimeout2['default'])(function () {
                pwdInput.focus();
            }, 500);
        }
    },
    onEmailChange: function onEmailChange(event) {
        this.setState({
            'emailAddress': event.target.value.trim()
        });
    },
    onPasswordChange: function onPasswordChange(event) {
        this.setState({
            'password': event.target.value
        });
    },
    onSubmit: function onSubmit(evt) {

        evt.preventDefault();

        if (this.state.isProcessing === false) {

            // Retrieve the values from the email/password field one more time
            // prior to submit. This fixes an issue where Safari auto-complete
            // would not trigger the on*Change events for these fields.
            var root = _reactDom2['default'].findDOMNode(this);
            var minPasswordLength = _hfReactHelper2['default'].HfConstants.minPasswordLength;
            var emailAddress = $('#login_email_address_input', root).val();
            var password = $('#login_password_input', root).val();

            this.setState({
                'errors': null,
                'isProcessing': true,
                'emailAddress': emailAddress,
                'password': password
            });

            if (!_hfReactHelper2['default'].isValidEmailAddress(emailAddress)) {

                this.setState({
                    'errors': { 'named': { 'email_address': 'Invalid email address' } },
                    'isProcessing': false
                });
            } else if (password.length < minPasswordLength) {

                this.setState({
                    'errors': { 'named': { 'password': 'Your password must be at least ' + minPasswordLength + ' characters long' } },
                    'isProcessing': false
                });
            } else if (!this.props.async) {

                // Inline submit
                $('#login_form', root).submit();
            } else {

                // Async submit
                this.submitAsync(function (resp) {

                    this.setState({
                        'isProcessing': false
                    });

                    // Close the login modal
                    if (resp.success) {
                        $('.m-modal--close', '#login_modal').click();
                    }

                    // Display notification
                    if (resp.notification) {
                        hellofaxJS.createNotification({
                            'text': resp.notification.message,
                            'class_name': resp.notification.type
                        });
                    }

                    // Redirect to on_login_redirect_url
                    if (resp.success === true && resp.on_login_redirect_url) {
                        document.location = resp.on_login_redirect_url;
                    }

                    // Failure
                    if (!resp.success) {

                        var hasErrorMsg = resp.error && resp.error.message;

                        if (this.state.isCaptchaDisplayed) {
                            // Refresh CAPTCHA
                            grecaptcha.reset();

                            if (hasErrorMsg) {
                                this.setState({
                                    'errors': { 'global': resp.error.message }
                                });
                            }
                        }

                        if (resp.display_captcha) {
                            if (!this.state.isCaptchaDisplayed) {
                                // Show CAPTCHA
                                this.setState({
                                    'isCaptchaDisplayed': true
                                });
                            }
                        } else if (resp.on_error_redirect_url) {
                            // Redirect to on_error_redirect_url
                            document.location = resp.on_error_redirect_url;
                        } else if (hasErrorMsg && !resp.notification_message) {
                            // Display error message
                            this.setState({
                                'isCaptchaDisplayed': resp.display_captcha,
                                'errors': { 'global': resp.error.message }
                            });
                        }
                    }
                }, function () {

                    // Unexpected error
                    this.setState({
                        'errors': { 'global': 'An unexpected error occurred' },
                        'isProcessing': false
                    });
                });
            }
        }
    },
    displayForgotPasswordModal: function displayForgotPasswordModal() {

        // Note: version 1.4.4 of jQuery is incompatible with Foundation.
        // In this case we'll want to redirect to / to use the regular login form
        if ($.fn.jquery === '1.4.4') {
            window.location = '/';
            return;
        }

        $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'close');
        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('forgot_password_modal', 'tiny');
        _reactDom2['default'].render(_react2['default'].createElement(_forgotPasswordModal2['default'], {
            emailAddress: this.state.emailAddress,
            recoverPasswordForm: this.props.recoverPasswordForm }), attachPoint);
    },
    render: function render() {

        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
        var rowClassNames = (0, _classnames2['default'])({
            'row': true,
            'text-center': true
        });

        var isCaptchaDisplayed = this.props.displayCaptcha || this.state.isCaptchaDisplayed;
        var buttonColumnClassNames = 'columns small-12 l-margin-v-20';
        var formColumnClassNames = buttonColumnClassNames + ' text-left m-login--sign-up';
        formColumnClassNames = isCaptchaDisplayed ? formColumnClassNames + ' m-login--sign-up-tall' : formColumnClassNames;

        var captcha;
        var errors;
        if (isCaptchaDisplayed) {
            captcha = _react2['default'].createElement(
                'div',
                { className: 'l-margin-b-5 small-10 small-offset-1 text-center' },
                _react2['default'].createElement(_loginCaptcha2['default'], { recaptchaPublicKey: this.props.recaptchaPublicKey, tabIndex: tabOffset + 4 })
            );
        }

        if (this.state.errors) {
            errors = _react2['default'].createElement(
                'div',
                { className: 'row' },
                _react2['default'].createElement(
                    'div',
                    { className: 'columns l-margin-b-10 small-10 small-offset-1 text-center m-modal--error' },
                    this.renderErrorText()
                )
            );
        }

        var buttonText = this.props.buttonText ? this.props.buttonText : 'SIGN UP FREE';
        if (this.props.async && this.state.isProcessing) {
            buttonText = 'PROCESSING...';
        }

        var googleOpenId;
        if (!this.props.hideGoogleOpenId) {
            googleOpenId = _react2['default'].createElement(
                'div',
                { className: buttonColumnClassNames + ' m-login--modal-google-login' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-login--modal-google-login-border' },
                    _react2['default'].createElement('div', { className: 'm-login--modal-google-login-or-image' })
                ),
                _react2['default'].createElement(_googleLoginOrSignup2['default'], { openIdUrl: this.props.googleOpenIdUrl, isLogIn: true })
            );
        }

        var rememberMe;
        if (!this.props.hideRememberMe) {
            rememberMe = _react2['default'].createElement(
                'div',
                { className: 'l-margin-b-10 small-10 small-offset-1 small-text-left' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-login--centering-container' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-login--alignment-wrapper' },
                        this.renderField('should_remember_me', {
                            'id': 'login[should_remember_me]',
                            'defaultChecked': 'checked',
                            'tabIndex': tabOffset + 3,
                            'className': 'm-login--text-input'
                        }),
                        _react2['default'].createElement(
                            'label',
                            { htmlFor: 'login[should_remember_me]' },
                            'Remember me'
                        )
                    )
                )
            );
        }

        return _react2['default'].createElement(
            'div',
            { className: 'm-login' },
            _react2['default'].createElement(
                'form',
                { ref: 'login_form', className: 'm-login--form', id: 'login_form', action: this.props.action, method: 'POST', onSubmit: this.onSubmit },
                _react2['default'].createElement(
                    'div',
                    { className: rowClassNames },
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12' },
                        _react2['default'].createElement(
                            'h3',
                            null,
                            this.props.header
                        )
                    ),
                    googleOpenId,
                    _react2['default'].createElement(
                        'div',
                        { className: formColumnClassNames },
                        _react2['default'].createElement(
                            'div',
                            { className: 'l-margin-b-10 small-10 small-offset-1 text-center' },
                            this.renderField('email_address', {
                                'id': 'login_email_address_input',
                                'className': 'm-login--text-input',
                                'placeholder': 'Email',
                                'onChange': this.onEmailChange,
                                'tabIndex': tabOffset,
                                'value': this.state.emailAddress
                            })
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'l-margin-b-5 small-10 small-offset-1 text-center' },
                            this.renderField('password', {
                                'id': 'login_password_input',
                                'className': 'm-login--text-input m-login--login-password',
                                'placeholder': 'Password',
                                'onChange': this.onPasswordChange,
                                'tabIndex': tabOffset + 1
                            })
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-login--forgot-pwd-link l-margin-b-10 small-10 small-offset-1 small-text-left' },
                            _react2['default'].createElement(
                                'div',
                                { className: 'm-login--centering-container' },
                                _react2['default'].createElement(
                                    'div',
                                    { className: 'm-login--alignment-wrapper' },
                                    _react2['default'].createElement(
                                        'a',
                                        { href: 'javascript:;', tabIndex: tabOffset + 2, onClick: this.displayForgotPasswordModal },
                                        'Forgot password?'
                                    )
                                )
                            )
                        ),
                        rememberMe,
                        this.renderHiddenFields(),
                        captcha,
                        errors,
                        _react2['default'].createElement(
                            'div',
                            { className: 'small-10 small-offset-1 text-center' + (this.props.isInline ? ' m-login--inline-google-login-button-container' : ' m-login--modal-google-login-button-container') },
                            _react2['default'].createElement(_button2['default'], { onClick: this.onSubmit,
                                buttonClass: this.props.isInline ? 'm-login--inline-google-login-button' : 'm-login--modal-google-login-button',
                                buttonText: buttonText,
                                buttonColor: 'grasshopper',
                                buttonHoverColor: 'castle-rock',
                                buttonTabIndex: tabOffset + 5 })
                        )
                    )
                ),
                _react2['default'].createElement('input', { type: 'hidden', name: 'on_error_redirect_url', value: this.props.onErrorRedirectUrl }),
                _react2['default'].createElement('input', { type: 'hidden', name: 'close_after_login', value: this.state.closeAfterLogin ? '1' : '0' }),
                _react2['default'].createElement('input', { type: 'hidden', name: 'login[redirect_url]', value: this.state.redirectUrl }),
                _react2['default'].createElement('input', { type: 'hidden', name: 'async', value: this.props.async ? '1' : '0' })
            )
        );
    }
});

module.exports = LogInForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/login-form.jsx
 ** module id = 877
 ** module chunks = 0
 **/